import StepperDataExport from '../3modules/DataExport/StepperDataExport'
import ContactNameSearch from '../2compounds/ContactNameSearch'
import BusinessDataSelectDataSetDropdown from '../2compounds/Select/BusinessDataTypeDropdown'
import {useState} from 'react'
import ConfirmationMessage from '../3modules/DataExport/ConfirmationMessage'
import ServiceTypeDropDown from '../2compounds/Select/ServiceTypeDropDown'
import ServiceSearch from '../2compounds/Search/ServiceSearch'
import ContactTypeDropDown from '../2compounds/Select/ContactTypeDropDown'
import makeStyles from '@material-ui/core/styles/makeStyles'
import FormErrorSnackbar from '../2compounds/FormErrorSnackbar'
import ClientSearch from '../3modules/AccountImport/ClientSearch'

const DataExportBusinessDataTemplate = ({dataSet, onDataSetChange, client, setClient, serviceTypeId, onServiceTypeChange,
    service, onServiceChange, disabled, contactTypeName, onContactTypeChange, contact, onContactChange, handleExportButton,
                                            isErrorSnackbarOpen, setIsErrorSnackbarOpen}) => {
    const classes = useStyles()
    const [detailType, setDetailType] = useState('')
    const secondStepLabel = detailType ? `Select ${detailType}` : ''
    const steps = ['Select Data Set', secondStepLabel, 'Export Business Data']
    const errorSnackbarMessage = 'Something went wrong. Please try it again later.'
    const DataSetDropdown = (<BusinessDataSelectDataSetDropdown value={dataSet} onChange={onDataSetChange}/>)

    const ServiceNameSearchField = (
        <div className={classes.secondStepDiv}>
            <ServiceTypeDropDown value={serviceTypeId} onChange={onServiceTypeChange} />
            <ServiceSearch service={service} onServiceChange={onServiceChange} selectedServiceTypeId={serviceTypeId} disabled={!serviceTypeId} />
        </div>
    )

    const ContactNameSearchField = (
        <div className={classes.secondStepDiv}>
            <ContactTypeDropDown value={contactTypeName} onChange={onContactTypeChange} />
            <ContactNameSearch value={contact} setValue={onContactChange} selectedContactType={contactTypeName} disabled={!contactTypeName} searchOnly />
        </div>
    )

    const ClientNameSearchField = (
        <ClientSearch selectedClient={client} setSelectedClient={setClient}
                      className={classes.searchField} includeAllClients />
    )

    const SelectDetail = () => {
        // TODO Do not hardcode.
        switch(dataSet){
            case 'All locations of a Client':
            case 'All info for a Client':
                setDetailType('Client')
                return ClientNameSearchField
            case 'All locations with this Service':
                setDetailType('Service')
                return ServiceNameSearchField
            case 'All locations assigned to a Contact':
            case 'All training records for a Contact':
                setDetailType('Contact')
                return ContactNameSearchField
            default:
                return ''
        }
    }

    const selectedValuesObject = () => {
        // TODO Do not hardcode.
        switch(dataSet){
            case 'All locations of a Client':
            case 'All info for a Client':
                return {'Data Set': dataSet, 'Client': client ? client.name : ''}
            case 'All locations with this Service':
                return {'Data Set': dataSet, 'Service Name': service?service.name:''}
            case 'All locations assigned to a Contact':
            case 'All training records for a Contact':
                return {'Data Set': dataSet, 'Contact Name': contact?contact.name:''}
            default:
                return ''
        }
    }

    const Confirm = (<ConfirmationMessage selectedValuesObject={selectedValuesObject()} />)

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return DataSetDropdown
            case 1:
                return SelectDetail()
            case 2:
                return Confirm
            default:
                return 'Unknown step';
        }
    }

    return (
        <>
            <StepperDataExport getStepContent={getStepContent} steps={steps} disabled={disabled} handleExportButton={handleExportButton} />
            <FormErrorSnackbar isSnackbarOpen={isErrorSnackbarOpen} setIsSnackbarOpen={setIsErrorSnackbarOpen} content={errorSnackbarMessage} />
        </>
    )
}

export default DataExportBusinessDataTemplate

const useStyles = makeStyles({
    secondStepDiv: {
        '&>*': {
            marginBottom: '15px'
        }
    },
    searchField: {
        maxWidth: '400px'
    }
})
